

























import TableActionDropdown from '@/components/TableActionDropdown.vue';
import { CourseLicenseTemplateResponse } from '@/jbi-shared/dto/jtms.dtos';
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

@Component({
  components: {
    TableActionDropdown
  }
})
export default class CourseLicenseTemplateRow extends Vue {
  @Prop() courseLicenseTemplate!: CourseLicenseTemplateResponse;

  @Emit('edit')
  emitEditEvent() {
    return this.courseLicenseTemplate;
  }

  @Emit('delete')
  emitDeleteEvent() {
    return this.courseLicenseTemplate;
  }
}
